import { useState } from 'react';

const InputURL = ({
  initialValue,
  onBlur,
}: {
  initialValue: string;
  onBlur: (urlId: string, newValue: string) => void;
}) => {
  const [value, setValue] = useState(initialValue);

  return (
    <>
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={() => onBlur(btoa(initialValue), value)}
      />
    </>
  );
};

export default InputURL;
